import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse } from '../types/api';

export interface CovidBadge {
  id?: number;
  userId: number;
  consented?: string | null;
}

const URL = '/v2/covid-badges';

class CovidBadgeService {
  static create(
    data: CovidBadge,
    config?: AxiosRequestConfig,
  ): Promise<DataResponse<CovidBadge>> {
    return axios.post(URL, data, config);
  }

  static update(
    id: number,
    data: CovidBadge,
    config?: AxiosRequestConfig,
  ): Promise<DataResponse<CovidBadge>> {
    return axios.put(`${URL}/${id}`, data, config);
  }
}

export { CovidBadgeService };
